<template>
  <b-nav-item-dropdown text="Lang" right no-caret @show="closeOpenPanels">
    <template slot="button-content">
      <span v-b-tooltip.hover.bottom :title="$t('navbar.language')">
        <b-img :src="require('../../../assets/flags/' + lang + '.png')" class="selectedFlag"></b-img>
        <i class="fas fa-chevron-down ml-1 small"></i>
      </span>
    </template>
    <b-dropdown-item
      v-for="(lang, index) in availableLanguages"
      :key="index"
      class="languages"
      href="#"
      @click.prevent="changeLanguage(lang)"
      :class="lang === $i18n.locale ? 'currentLang' : ''"
    >
      <b-img :src="require('../../../assets/flags/' + lang + '.png')" class="tinyFlag"></b-img>
      {{ lang }}
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
export default {
  name: 'LanguagesBar',

  methods: {
    changeLanguage(newLanguage) {
      this.$i18n.locale = newLanguage
      localStorage.setItem('language', newLanguage)
    },
    closeOpenPanels() {
      this.$emit('on-close-open-panels')
    },
  },
  computed: {
    lang: function () {
      return this.$i18n.locale
    },
    availableLanguages: function () {
      return this.$i18n.availableLocales
    },
  },
}
</script>

<style lang="scss">
.navbar-primary a {
  color: var(--white);
}

.selectedFlag {
  margin-top: -3px;
  height: 1rem;
  width: 1.4rem;
}

.tinyFlag {
  height: 0.8rem;
  width: 1.1rem;
}

.currentLang a {
  font-weight: bold !important;
}

.languages a {
  padding: 10px 20px !important;
  color: black !important;
  font-size: 0.8rem;
}

.languages a:hover {
  color: black !important;
  background-color: #f8f9fa;
}
</style>
